import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";
import * as pageActions from "../pages/actions";

export function saveLVGoalsPDF(payload) {
  return { type: actionTypes.SAVE_LG_PDF, payload };
}

export function saveLVGoalsPDFSuccess(payload) {
  return { type: actionTypes.SAVE_LG_PDF_SUCCESS, payload };
}